import { set } from 'idb-keyval';
import {
  UserAccessTokenClient,
  UserAuthClient,
  UserAuthRefreshClient,
} from '../httpClient';
import featureFlags from '../../helpers/featureFlags';
import { clearAllTokens, getAllTokens } from './userTokenService';
import authorizationService from './authorizationService';

export const refreshTokens = async () => {
  const INDEXDB_PROJECT_TOKEN_KEY = 'projectToken';
  const urlPathNameSplit = window.location.pathname?.split('/');
  let response;
  if (featureFlags.isUserAccessTokenV2Enabled) {
    if (!authorizationService.hasValidRefreshToken()) return;
    response = await UserAuthRefreshClient.get(
      `v2/access/tokens/refresh?redirectUri=${window.location.origin}/access`
    );
  } else {
    response = await UserAuthClient.get(
      `access/refreshTokens?redirectUri=${window.location.origin}/access`
    );
  }

  if (
    urlPathNameSplit?.[0] === '' &&
    urlPathNameSplit?.[1] === 'projects' &&
    urlPathNameSplit?.[2] &&
    // eslint-disable-next-line use-isnan
    Number(urlPathNameSplit?.[2]) !== NaN &&
    typeof Number(urlPathNameSplit?.[2]) === 'number'
  ) {
    const projectId = urlPathNameSplit?.[2];
    if (projectId) {
      const projectToken = response?.data?.projectTokens?.find(
        (projctToken) => projctToken?.projectId === Number(projectId)
      );
      set(INDEXDB_PROJECT_TOKEN_KEY, projectToken?.token);
    }
  }
  await authorizationService.setTokens(response.data);
};

export const invalidateTokens = async () => {
  const tokens = getAllTokens();
  clearAllTokens();

  if (tokens.length) {
    try {
      await UserAccessTokenClient.post('access/invalidateTokens', {
        tokens,
      });
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }
};

export const getAuthenticationUrl = async (redirectUri, state) => {
  const response = await UserAccessTokenClient.get(
    `access/authenticationUrl?redirectUri=${redirectUri}&state=${state}`
  );

  return response.data;
};

export const getSignoutUrl = async () => {
  const response = await UserAccessTokenClient.get(`access/signOutUrl`);

  return response.data;
};

export const getTokens = async (accessCode) => {
  const response = await UserAccessTokenClient.get(
    `${
      featureFlags.isUserAccessTokenV2Enabled ? 'v2/' : ''
    }access/tokens?code=${accessCode}&redirectUri=${
      window.location.origin
    }/access`
  );

  return response.data;
};
